<template>
  <div class="auth-page">
    <div class="auth-frame">
      <div class="auth-frame__showcase d-none d-lg-block">
        <auth-showcase />
      </div>

      <div class="auth-frame__panel">
        <div class="auth-form">
          <div class="auth-brand">
            <b-img
              :src="appLogoImage"
              alt=""
              class="auth-brand__icon"
            />
            <span class="auth-brand__name">YoConstruyo</span>
          </div>
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BImg } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'
import AuthShowcase from '@/components/auth/AuthShowcase.vue'

export default {
  components: {
    BImg,
    AuthShowcase,
  },

  data() {
    return {
      appLogoImage: $themeConfig.app.appLogoImage,
    }
  },
}
</script>

<style lang="scss" scoped>
@import './auth-page.scss';
</style>
